module.exports = __webpack_public_path__ + "img/ring_r_l_null_1@3x.6cacaa1c.png";